import { Breadcrumb, COLLECTING_BREADCRUMB } from "@/components/PageHeader/PageHeaderNew";

export const PRODUCTS_BREADCRUMBS: Breadcrumb[] = [
  COLLECTING_BREADCRUMB,
  {
    label: "Products",
    url: "/products",
  },
];
